import { useCallback, useState } from 'react';
import API from '../../../Infrastructure/API';

interface Settings {
  authToken?: string;
  enabled?: boolean;
}

export default function useMultiFactorAuthenticationRequest({ authToken, enabled = true }: Settings) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  const request = useCallback(
    (authenticationId: string) => {
      if (!authToken || !enabled) {
        return;
      }

      setLoading(true);
      setError(false);

      API.multiFactorAuthentication
        .request(authenticationId, { authToken })
        .then(() => {
          setFetched(true);
        })
        .catch(() => {
          setError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [authToken, enabled],
  );

  return {
    request,
    loading,
    error,
    fetched,
  };
}
